/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IExample } from './IExample';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IExamplesParent {
    /**
     * Creates a child Example model.
     * @param {string} name
     * @return {*}
     */
    createExample(name : string) : IExample;

    /**
     * Adds the Example to the map of examples.
     * @param {*} example
     */
    addExample(example : IExample);

    /**
     * Removes an Example and returns it.
     * @param {string} name
     * @return {*}
     */
    removeExample(name : string) : IExample;

    /**
     * Gets a single example by name.
     * @param {string} name
     * @return {*}
     */
    getExample(name : string) : IExample;

    /**
     * Gets all examples.
     * @return {*[]}
     */
    getExamples() : Array<IExample>;

    /**
     * Remove all examples.
     */
    clearExamples();
}


